import { render } from "./SessionsList.vue?vue&type=template&id=bd9fc3f6&scoped=true"
import script from "./SessionsList.vue?vue&type=script&lang=js"
export * from "./SessionsList.vue?vue&type=script&lang=js"

import "./SessionsList.vue?vue&type=style&index=0&id=bd9fc3f6&scoped=true&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd9fc3f6"]])

export default __exports__